var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 107.79
  }), /*#__PURE__*/React.createElement("rect", {
    y: 404.21,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 107.79
  })), /*#__PURE__*/React.createElement("rect", {
    y: 107.79,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 296.42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M284.79,346.631l124.519-24.904c8.986-1.797,12.998-12.374,7.465-19.679l0,0  c-1.943-2.565-4.807-4.276-7.987-4.772l-132.654-20.683c-3.666-0.572-6.264-4.014-5.647-7.822c0.597-3.685,4.331-6.032,8.032-5.545  l91.975,12.102c7.475,0.984,12.06-7.949,6.904-13.449l-7.383-7.876c-2.764-2.949-6.389-4.95-10.357-5.718l-76.833-14.879  l65.511,4.719c5.022,0.362,7.931-5.574,4.568-9.322l-3.36-3.744c-2.03-2.262-4.73-3.818-7.705-4.44l-65.041-13.592l46.224-1.338  c4.087-0.118,6.166-4.964,3.435-8.007l-2.073-2.309c-1.623-1.809-3.723-3.124-6.06-3.795l-41.225-11.836h32.398  c3.205,0,5.361-3.284,4.086-6.224l-1.092-2.521c-1.311-3.025-3.838-5.356-6.96-6.418l-29.961-10.192l14.735-0.048  c4.379-0.014,7.316-4.503,5.575-8.521l0,0c-1.403-3.237-3.879-5.891-7.01-7.514L256,121.263l-32.867,17.04  c-3.132,1.624-5.608,4.278-7.01,7.514l0,0c-1.741,4.018,1.195,8.507,5.575,8.521l14.735,0.048l-29.961,10.192  c-3.121,1.062-5.649,3.393-6.96,6.418l-1.092,2.521c-1.274,2.941,0.881,6.224,4.086,6.224h32.398l-41.225,11.836  c-2.336,0.671-4.436,1.986-6.06,3.795l-2.073,2.309c-2.731,3.043-0.652,7.889,3.435,8.007l46.224,1.338l-65.041,13.592  c-2.976,0.622-5.675,2.177-7.705,4.44l-3.36,3.744c-3.363,3.747-0.454,9.683,4.568,9.322l65.511-4.719l-76.833,14.879  c-3.968,0.768-7.592,2.77-10.357,5.718l-7.383,7.876c-5.157,5.501-0.572,14.433,6.904,13.449l91.975-12.102  c3.701-0.487,7.435,1.86,8.032,5.545c0.617,3.808-1.981,7.25-5.647,7.822l-132.653,20.683c-3.18,0.496-6.043,2.207-7.987,4.772l0,0  c-5.534,7.305-1.522,17.882,7.465,19.679l124.519,24.904v15.54c0,8.484-3.37,16.62-9.369,22.619l-19.42,19.42H256h57.579  l-19.42-19.42c-5.999-5.999-9.369-14.135-9.369-22.619V346.631z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLb);
export default __webpack_public_path__ + "static/media/LB.dfb9b44a889d4e05a007d5a4446981fe.svg";
export { ForwardRef as ReactComponent };